import { Header } from "../../components/Header"
import { useParams } from "react-router-dom";
import { Port } from "../../components/Port";
import { PortData, getPort } from "../../remote/scan_data";
import { useEffect, useState } from "react";
import { ScanChildren } from "../../components/ScanChildren";
import { Box, CircularProgress, Container } from "@mui/material";

export const TreePort = () => {
	const params = useParams()
	const entityId = params.entityId;

	if ( ! entityId) {
		return <CircularProgress />
	}

	const [portData, setPortData] = useState<PortData | null>(null);
	useEffect(() => {
		getPort(entityId, (data, resp) => {
			if (data) {
				setPortData(data);
			} else {
				setPortData(null);
			}
		});
	}, [setPortData]);

	return (portData ? <>
		<Header />
		<Container>
			<Port id={entityId} data={portData} hideChildren/>
			<Box margin={1}></Box>
			<ScanChildren data={portData.children} />
		</Container>
	</> : <CircularProgress />)
}
